export const awaitOfficeDefined = async () => {
  while (!Object.hasOwn(window, "Office")) {
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
};
